// SaldoSueltas.jsx
//
// #1887 · «Mi suscripción» muestra el saldo de jornadas sueltas y su vencimiento (spec `.claude/specs/jornada-suelta/`, T30, R37), con
// la opción de comprar otra cuando `GET /me/suelta/` lo permite. Todo sale de esa respuesta (`saldo`, `vence_en`, `disponible`): ni el
// saldo ni la fecha se calculan acá. Sin saldo el nodo NO existe (no hay nada que mostrar: la compra se ofrece en la banda de /turno).
// Cubre R37 — .claude/specs/jornada-suelta/
import { Box, Button } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useOfertaSuelta } from "../../hooks/useJornadaEstado";
import { abrirCompraSuelta, diaMes } from "../../helpers/suelta-api";
import { botonGhostSx } from "../checkout/botonesSx";

const TIPOS = [
  ["12h", "de 12\u00a0h"],
  ["24h", "de 24\u00a0h"],
];

const SaldoSueltas = () => {
  const { oferta } = useOfertaSuelta();
  const saldo = oferta?.saldo || {};
  const filas = TIPOS.filter(([t]) => Number(saldo[t]) > 0);
  if (!oferta || !filas.length) return null;
  return (
    <Box data-testid="mi-suscripcion-suelta" sx={{ mb: 1.75, pt: 1.75, borderTop: "1px solid var(--border-soft)" }}>
      <Box sx={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 0.6, color: "var(--text-faint)", fontWeight: 700 }}>Jornadas adicionales guardadas</Box>
      <Box sx={{ mt: 0.5, display: "grid", gap: 0.4 }}>
        {filas.map(([tipo, nombre]) => {
          const n = Number(saldo[tipo]);
          const vence = oferta.vence_en?.[tipo];
          return (
            <Box key={tipo} data-testid={`mi-suscripcion-suelta-${tipo}`} sx={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)" }}>
              {`${n} ${nombre}`}
              {vence ? (
                <Box component="span" sx={{ fontWeight: 500, color: "var(--text-muted)" }}>
                  {` · ${n === 1 ? "vence" : "vencen"} el ${diaMes(vence)}`}
                </Box>
              ) : null}
            </Box>
          );
        })}
      </Box>
      {oferta.disponible ? (
        <Button
          data-testid="mi-suscripcion-suelta-comprar"
          variant="outlined"
          size="small"
          startIcon={<AddCircleOutlineIcon />}
          onClick={abrirCompraSuelta}
          sx={{ ...botonGhostSx, mt: 1.25 }}
        >
          Sumar otra
        </Button>
      ) : null}
    </Box>
  );
};

// Subtítulo de «Mi suscripción → Sin plan» según haya o no jornadas adicionales guardadas (aprobado por Sebastián el 30-oct-2026,
// corrección (c)): sin saldo no se habla de «tus jornadas guardadas», que no existen. Vive acá porque usa el mismo hook del saldo.
export const SubtituloSinPlan = () => {
  const { oferta } = useOfertaSuelta();
  const saldo = oferta?.saldo || {};
  const hay = TIPOS.some(([t]) => Number(saldo[t]) > 0);
  return hay
    ? "Sigues entrando a leer, copiar, editar y guardar. Para generar con IA activas tus jornadas adicionales guardadas con el botón, o eliges un plan."
    : "Sigues entrando a leer, copiar, editar y guardar. Para generar con IA sumas jornadas adicionales o eliges un plan.";
};

export default SaldoSueltas;
